export const MailIcon = ({...props}) => {
    return (
        <>
            <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.5 0.25H1.5C1.33424 0.25 1.17527 0.315848 1.05806 0.433058C0.940848 0.550269 0.875 0.70924 0.875 0.875V11.5C0.875 11.8315 1.0067 12.1495 1.24112 12.3839C1.47554 12.6183 1.79348 12.75 2.125 12.75H15.875C16.2065 12.75 16.5245 12.6183 16.7589 12.3839C16.9933 12.1495 17.125 11.8315 17.125 11.5V0.875C17.125 0.70924 17.0592 0.550269 16.9419 0.433058C16.8247 0.315848 16.6658 0.25 16.5 0.25ZM14.893 1.5L9 6.90234L3.10703 1.5H14.893ZM15.875 11.5H2.125V2.29609L8.57734 8.21094C8.69265 8.31679 8.84348 8.37552 9 8.37552C9.15652 8.37552 9.30735 8.31679 9.42266 8.21094L15.875 2.29609V11.5Z" fill="#3D3D3D"/>
            </svg>
        </>
    );
}
